import React, { useEffect } from 'react'
import { useQuery } from '@apollo/client'
import { Table } from '../Table'

import {
  missingnessInfo,
  entryTermInfo,
  numRecordsColumnInfo,
  outOfBoundsInfo,
  summaryStatisticsInfo,
  summaryStatisticsInfoAdmin,
} from './qcFields'
import { useDashboardContext } from '../react-context'
import { GET_QC_MODAL_DATA_BY_JOB_ID } from '@landscape/gql'
import { CLIENT_TYPE } from '../Utils'
import {Spinner} from "../Spinner";

export const MissingnessTableTitle = 'Missingness Percentages'
const OutOfBoundsTitle = 'Out Of Bounds Percentages'
const SummaryStatisticsTitle = 'Summary Statistics Percentages'

const sharedTableProps = {
  sortable: false,
}

const entryTermColInfo = { ...entryTermInfo, ...sharedTableProps }
const numRecordsColInfo = { ...numRecordsColumnInfo, ...sharedTableProps }

// for the qc modal, we need the group by column (entry_term) to be added
export const missingnessColumns = [entryTermColInfo, numRecordsColInfo]
missingnessInfo.forEach(({ uniqueField, label }) => {
  missingnessColumns.push({
    field: uniqueField,
    label,
    ...sharedTableProps,
  })
})

export const outOfBoundsColumns = [entryTermColInfo]
outOfBoundsInfo.forEach(({ uniqueField, label }) => {
  outOfBoundsColumns.push({
    field: uniqueField,
    label,
    ...sharedTableProps,
  })
})

export const summaryStatisticsColumns = [entryTermColInfo]
summaryStatisticsInfo.forEach(({ uniqueField, label }) => {
  summaryStatisticsColumns.push({
    field: uniqueField,
    label,
    ...sharedTableProps,
  })
})

export const summaryStatisticsColumnsAdmin = [entryTermColInfo]
summaryStatisticsInfoAdmin.forEach(({ uniqueField, label }) => {
  summaryStatisticsColumnsAdmin.push({
    field: uniqueField,
    label,
    ...sharedTableProps,
  })
})
// add in the entry_term manually

export const QualityControlTable: React.FC<any> = ({ jobId, clientType, diCode, onDataLoadCallback }) => {
  // Only the internal admin SS cols modal will contain hist, yoy, stage
  let ssColumnType = clientType === CLIENT_TYPE.INTERNAL ? summaryStatisticsColumnsAdmin : summaryStatisticsColumns

  const { loading, data, refetch } = useQuery(GET_QC_MODAL_DATA_BY_JOB_ID, {
    // we are passing in diCode here, however it will be ignored and the diCode will
    // be taken from the graphql server context instead for ui-dashboard calls
    variables: {
      input: {
        jobId,
        diCode: diCode.toString(),
        fileName: '',
      } },
    fetchPolicy: 'cache-and-network',
  })
  useEffect(() => {
    if (onDataLoadCallback && !loading && data?.getQcModalDataQuery?.length) {
      onDataLoadCallback()
    }
  }, [loading, onDataLoadCallback, data])
  const dashboardReactContext = useDashboardContext()
  dashboardReactContext.refetchQcModal = refetch

  if (data?.getQcModalDataQuery?.length) {
    return <div id="qc-table">
      <div data-testid="missingness-table">
        <Table
            data={data.getQcModalDataQuery}
            columns={missingnessColumns}
            defaultSortField="entry_term"
            defaultSortAsc={false}
            uniqueKeyColumn="id"
            title={MissingnessTableTitle}
            titlePosition="start"
        />
      </div>
      <div data-testid="outOfBounds-table">
        <Table
            data={data.getQcModalDataQuery}
            columns={outOfBoundsColumns}
            defaultSortField="entry_term"
            defaultSortAsc={false}
            uniqueKeyColumn="id"
            title={OutOfBoundsTitle}
            titlePosition="start"
        />
      </div>
      <div data-testid="summaryStatistics-table">
        <Table
            data={data.getQcModalDataQuery}
            columns={ssColumnType}
            defaultSortField="entry_term"
            defaultSortAsc={false}
            uniqueKeyColumn="id"
            title={SummaryStatisticsTitle}
            titlePosition="start"
        />
      </div>
    </div>
  } else {
    return <Spinner showSpinner={true} size="xs" id="qc-modal-spinner" ariaLabel="Generating Report..." />
  }


}
